var map = {
	"./echo/all-source.js": "5947",
	"./joychat/all-source.js": "a745",
	"./joyu/all-source.js": "4261",
	"./kiko/all-source.js": "a372",
	"./vava/all-source.js": "1524",
	"./vibeo/all-source.js": "5a59",
	"./whonow/all-source.js": "4a35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f10";